import { Fragment } from "react";
import { Disclosure } from "@headlessui/react";

const classNames = (...classes) => classes.filter(Boolean).join(" ");

export default function Accordion({ items = [] }) {
  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  return (
    <ul className="b-accordion__items" data-accordion-items>
      {items.map((item, index) => (
        <Disclosure
          as={Fragment}
          key={item.id || `accordion-item-${index}`}
          defaultOpen={Boolean(item.defaultOpen)}
        >
          {({ open }) => (
            <li
              className={classNames("b-accordion__item", open && "is-open")}
              data-accordion-item
              data-open={open ? "true" : "false"}
            >
              <Disclosure.Button
                className="b-accordion__trigger"
                data-accordion-item-trigger
                type="button"
              >
						    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" fill="none" viewBox="0 0 8 12"><path stroke="#000" strokeWidth="2" d="m.707.707 5 5-5 5"/></svg>
                <span>{item.title}</span>
              </Disclosure.Button>
              <Disclosure.Panel
                className="b-accordion__item-body"
                data-accordion-item-body
                static={false}
                unmount={false}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: item.body || "",
                  }}
                />
              </Disclosure.Panel>
            </li>
          )}
        </Disclosure>
      ))}
    </ul>
  );
}
